// 10カードに大カードを2個ランダム配置
// 大カード(2x2)は4列グリッドで2マス×2マス占める
// 配置可能な「大の起点」は限定される(右端や下端で空白を出さないため)

const cards = document.querySelectorAll('.card');
const totalCards = cards.length;

// 4列グリッドで大カード(span 2 × span 2)を配置
// シンプルに固定位置で確実に: 0番目と5番目を大カードに
// → 0番が大なら 0,1列・1,2行を占める → 残りは2,3列の1行目に2-3番、2行目に6-7番
// → 5番が大なら 1,2列・2,3行を占める...だとぶつかるので調整
//
// 安全に試す: 0番大カード(0-1列、1-2行)+ 6番大カード(2-3列、3-4行)
const safeLargePositions = [0, 1, 4, 5];

// シンプル化: ランダムから2個選んで、衝突しない組み合わせのみ採用
function pickValidTwo(arr) {
  const validPairs = [];
  for (let i = 0; i < arr.length; i++) {
    for (let j = i + 1; j < arr.length; j++) {
      const a = arr[i], b = arr[j];
      // 縦に隣接(差4)→ 大カード2行占めるので衝突
      if (b - a === 4) continue;
      // 横に隣接かつ同じ行 → 大カード横2列占めるので衝突
      if (b - a === 1 && Math.floor(a / 4) === Math.floor(b / 4)) continue;
      // 同じ行に2つ大カードがある → 横に並んじゃうので除外
      if (Math.floor(a / 4) === Math.floor(b / 4)) continue;
      validPairs.push([a, b]);
    }
  }
  if (validPairs.length === 0) return null;
  return validPairs[Math.floor(Math.random() * validPairs.length)];
}

const chosen = pickValidTwo(safeLargePositions);
if (chosen) {
  chosen.forEach(idx => {
    if (cards[idx]) cards[idx].classList.add('size-large');
  });
}

// タップでフリップ(スマホ)
cards.forEach(card => {
  card.addEventListener('click', function() {
    this.classList.toggle('tapped');
  });
});

// ヘッダーのスクロール変色(index ページのみ、他ページは Liquid で .scrolled 初期付与済み)
const siteHeader = document.querySelector('.site-header');
const isIndex = document.body.classList.contains('template-index');
if (siteHeader && isIndex) {
  const scrollHandler = () => {
    if (window.scrollY > 80) {
      siteHeader.classList.add('scrolled');
    } else {
      siteHeader.classList.remove('scrolled');
    }
  };
  window.addEventListener('scroll', scrollHandler, { passive: true });
  scrollHandler(); // 初期状態の確認
}

// スクロール連動フェードイン(Intersection Observer)
(function() {
  if (!('IntersectionObserver' in window)) {
    // 古いブラウザは即座に表示
    document.querySelectorAll('.card, .osusowake').forEach(function(el) {
      el.classList.add('in-view');
    });
    return;
  }
  
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); // 1度発火したら監視解除
      }
    });
  }, {
    threshold: 0.15,         // 15%見えた時に発火
    rootMargin: '0px 0px -50px 0px'  // 画面下から50px手前で発火
  });
  
  // カードと、お裾分けセクションを監視
  document.querySelectorAll('.card, .osusowake').forEach(function(el) {
    observer.observe(el);
  });
})();

// お裾分けチップ(セクション通過後に出現、クリックでスクロール、×で永久に消す)
// chip HTML は script タグより後ろなので DOMContentLoaded で待つ必要がある
(function() {
  function init() {
    var section = document.querySelector('.osusowake');
    var chip = document.getElementById('osusowake-chip');
    var closeBtn = document.getElementById('osusowake-chip-close');
    if (!chip) return;

    var dismissed = false;

    chip.addEventListener('click', function(e) {
      if (closeBtn && (e.target === closeBtn || closeBtn.contains(e.target))) return;
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        dismissed = true;
        chip.classList.add('hidden');
      });
    }

    // セクション上端が viewport 上端を超えたら chip を表示、戻ったら隠す
    if (!section) return;
    var ticking = false;
    function updateChip() {
      ticking = false;
      if (dismissed) return;
      if (section.getBoundingClientRect().top < 0) {
        chip.classList.remove('hidden');
      } else {
        chip.classList.add('hidden');
      }
    }
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateChip);
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', updateChip, { passive: true });
    updateChip();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ハンバーガーメニュー開閉
(function() {
  var toggle = document.getElementById('site-nav-toggle');
  var close = document.getElementById('site-nav-close');
  var overlay = document.getElementById('site-nav-overlay');
  if (!toggle || !overlay) return;
  
  function openMenu() {
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  
  toggle.addEventListener('click', openMenu);
  if (close) close.addEventListener('click', closeMenu);
  
  // オーバーレイの背景クリックでも閉じる
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeMenu();
  });
  
  // Escキーで閉じる
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('open')) closeMenu();
  });
  
  // メニュー内のリンククリックで閉じる
  overlay.querySelectorAll('a').forEach(function(link) {
    link.addEventListener('click', closeMenu);
  });
})();
